import React, {useEffect, useState} from 'react';
import {getReportParams, report} from '../../../../../../middleware/report';
import gaParams from '../../../../../../utilities/analytics/constants';
import {gaEvent} from '../../../../../../utilities/analytics/tracking';
import BtnRightSideText from '../../../../../Shared/Buttons/BtnRightSideText';
import PopUp from '../../../../../Shared/Popup/PopUp';
import TextInput from '../../../../../Shared/TextInput/TextInput';
import PlaneLoader from '../../../../AbroadTicketBlock/PlaneLoader';
import PaperPlane from '../../SVG/PaperPlane';
import Phone from '../../SVG/Phone';
import './idInsertScreen.scss';

const IdInsertScreen = (props) => {
  const [thisId, setThisId] = useState('');
  const [idError, setError] = useState(null);
  const [canCreateNew, setCreateNew] = useState(false);
  const [canProceedNew, setProceedNew] = useState(false);
  const [showPopUpGeneral, setPopUpGeneral] = useState(false);
  const [showPopUpNewBan, setPopUpNewBan] = useState(false);
  const [popupCode, setPopupCode] = useState('');
  const [wasErrored, setWasErrored] = useState(false);

  useEffect(() => {
    let reportParams = getReportParams();
    reportParams.area = 'SelfCare';
    reportParams.subArea = 'Cellcom Abroad';
    reportParams.channel = 'WebsiteBusiness';
    reportParams.actionType = 'Separated user shown';
    reportParams.status = 'Ongoing';
    reportParams.messageText = 'Separated user shown';
    reportParams.subscriber = props.subscriber;
    reportParams.param1 = 'WEBSITE';
    if (props.isJET) {
      reportParams.param1 = 'JET';
    }
    reportParams.param3 = 'מכר בהפרדה';
    report(reportParams);

    gaEvent(
      gaParams.SEPARATED_IDSCREEN_SHOW.category,
      gaParams.SEPARATED_IDSCREEN_SHOW.eventType,
      gaParams.SEPARATED_IDSCREEN_SHOW.eventParams
    );
  }, []);

  const is_israeli_id_number = (id) => {
    return (
      /\d{9}/.test(id) &&
      !id.match(/^0*$/) &&
      Array.from(id, Number).reduce((counter, digit, i) => {
        const step = digit * ((i % 2) + 1);
        return counter + (step > 9 ? step - 9 : step);
      }) %
        10 ===
        0
    );
  };

  const proceedToTicket = (id) => {
    let reportParams = getReportParams();
    reportParams.area = 'SelfCare';
    reportParams.subArea = 'Cellcom Abroad';
    reportParams.channel = 'WebsiteBusiness';
    reportParams.actionType = 'Separated user identified';
    reportParams.status = 'Ongoing';
    reportParams.messageText = 'Separated user identified';
    reportParams.subscriber = props.subscriber;
    reportParams.param1 = 'WEBSITE';
    if (props.isJET) {
      reportParams.param1 = 'JET';
    }
    reportParams.param3 = 'מכר בהפרדה';
    report(reportParams);
    props.handler(id);
  };

  const validateId = () => {
    if (wasErrored) {
      gaEvent(
        gaParams.SEPARATED_IDSCREENCONTINUEAFTERERRORS_CLICK.category,
        gaParams.SEPARATED_IDSCREENCONTINUEAFTERERRORS_CLICK.eventType,
        gaParams.SEPARATED_IDSCREENCONTINUEAFTERERRORS_CLICK.eventParams
      );
    } else {
      gaEvent(
        gaParams.SEPARATED_IDSCREENCONTINUE_CLICK.category,
        gaParams.SEPARATED_IDSCREENCONTINUE_CLICK.eventType,
        gaParams.SEPARATED_IDSCREENCONTINUE_CLICK.eventParams
      );
    }
    if (thisId != null && thisId != '') {
      if (props.data?.effectiveSocExists) {
        if (props.data.id == thisId) {
          if (props.data.status.toUpperCase() == 'Y' || props.data.status.toUpperCase() == 'S') {
            setPopupCode('12');
            setPopUpGeneral(true);
            gaEvent(
              gaParams.SEPARATED_CUSTOMERINDEBT_SHOW.category,
              gaParams.SEPARATED_CUSTOMERINDEBT_SHOW.eventType,
              gaParams.SEPARATED_CUSTOMERINDEBT_SHOW.eventParams
            );
          } else {
            if (!props.billingData) {
              props.BillingCheck({subscriber: props.subscriber}).then((res) => {
                const billingData = res.payload.Body;
                if (billingData.validationError) {
                  setPopUpGeneral(true);
                  setProceedNew(false);
                  setCreateNew(true);
                  setPopupCode('');
                } else {
                  proceedToTicket(thisId);
                }
              });
            } else {
              if (props.billingData.validationError) {
                setPopUpGeneral(true);
                setProceedNew(false);
                setCreateNew(true);
                setPopupCode('');
              } else {
                proceedToTicket(thisId);
              }
            }
          }
        } else {
          setError('ת.ז שהוזנה לא בדיוק זהה למה שרשום אצלנו');
          setWasErrored(true);
          setProceedNew(false);
          setCreateNew(true);
          props.PlantMemo({
            banId: props.data?.ban,
            soc: props.soc,
            subscriber: props.subscriber,
            shadowBan: props.data?.ban,
            memoType: '6',
          });
        }
      } else {
        if (props.data.id == thisId) {
          if (!props.billingData) {
            props.BillingCheck({subscriber: props.subscriber}).then((res) => {
              const billingData = res.payload.Body;
              if (billingData.validationError) {
                setPopUpGeneral(true);
                setProceedNew(false);
                setCreateNew(true);
                setPopupCode('');
              } else {
                proceedToTicket(thisId);
              }
            });
          } else {
            if (props.billingData.validationError) {
              setPopUpGeneral(true);
              setProceedNew(false);
              setCreateNew(true);
              setPopupCode('');
            } else {
              proceedToTicket(thisId);
            }
          }
        } else {
          setError('ת.ז שהוזנה לא בדיוק זהה למה שרשום אצלנו');
          setWasErrored(true);
          setCreateNew(true);
          setPopupCode('');
          setProceedNew(true);
          gaEvent(
            gaParams.SEPARATED_IDDOESNTMATCH_SHOW.category,
            gaParams.SEPARATED_IDDOESNTMATCH_SHOW.eventType,
            gaParams.SEPARATED_IDDOESNTMATCH_SHOW.eventParams
          );
        }
      }
    } else {
      setError('ת.ז שהוזנה לא תקינה');
    }
  };

  const toNewBan = canCreateNew ? (
    <>
      <p style={{marginBottom: '5px'}}>אנא הזן את תעודת הזהות מחדש או</p>
      <p>
        <a
          onClick={() => {
            gaEvent(
              gaParams.SEPARATED_TONEWACCOUNT_CLICK.category,
              gaParams.SEPARATED_TONEWACCOUNT_CLICK.eventType,
              gaParams.SEPARATED_TONEWACCOUNT_CLICK.eventParams
            );
            if (canProceedNew) props.goToDetailInsert(thisId);
            else {
              setPopUpNewBan(true);
              gaEvent(
                gaParams.SEPARATED_CANTGOTONEW_SHOW.category,
                gaParams.SEPARATED_CANTGOTONEW_SHOW.eventType,
                gaParams.SEPARATED_CANTGOTONEW_SHOW.eventParams
              );
            }
          }}>
          הגדר חשבון חדש {'>'}
        </a>
      </p>
    </>
  ) : null;

  return (
    <>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          const checkingId = is_israeli_id_number(thisId);
          if (checkingId) {
            validateId(thisId);
          }
        }}>
        <div className='cellcomSeparatedIdInsert'>
          {props.isLoading ? (
            <div className='loader-wrapper'>
              <PlaneLoader />
            </div>
          ) : null}
          <div className='subscriberHeading'>מנוי {props.subscriber}</div>
          <div className='mainHeading'>רגע לפני שממשיכים...</div>
          <div className='subParagraph'>להשלמת הרכישה הזינו את מספר תעודת הזהות של בעל המנוי</div>
          <div className='personalIdInsert'>
            <div className='subHeading'>כל השדות המסומנים הינם שדות חובה</div>
            <TextInput
              placeholder='תעודת זהות'
              name='id'
              maxLength='9'
              onChange={(e) => {
                setThisId(e.target.value.replace(/[^0-9]/g, ''));
                setError(null);
              }}
              value={thisId}
              type='text'
              inputMode='numeric'
              error={idError}
            />
            <div className='bottomHeading'>נוודא שזה רק אכן הפרטים שלך</div>
          </div>
          <div className='bottomDisclaimer'>
            {toNewBan}
            שימו לב, כדי לרכוש את החבילה דרך הארגון, יש לפנות לאיש הקשר
          </div>

          <PopUp
            showPopUp={showPopUpGeneral}
            onClose={() => {
              setPopUpGeneral(false);
            }}>
            <div className='mainHeading p-0 m-0'>רק רגע, יש פה עניין</div>
            <div className='plane'>
              <PaperPlane />
            </div>
            <div className='popupExplanation'>
              <b>
                אי אפשר לרכוש חבילת חו"ל עם תעודת
                <br />
                הזהות שהזנת
              </b>
            </div>
            <div className='popupCode'>{popupCode}</div>
            <div className='popupContactBox'>
              <div className='popupContactExplanation'>לבירור אפשר להתקשר למוקד השירות שלנו</div>
              <div
                className='contactWrapper'
                onClick={() => {
                  window.location.href = `tel:${window.Config.financeCallNumber2}`;
                }}>
                <Phone />
                <span style={{padding: '0 7px'}}>הקליקו לשיחה</span>
                <span>{window.Config.financeCallNumber2}</span>
              </div>
            </div>
          </PopUp>
          <PopUp
            showPopUp={showPopUpNewBan}
            onClose={() => {
              setPopUpNewBan(false);
            }}>
            <div className='mainHeading p-0 m-0'>רק רגע....</div>
            <div className='plane'>
              <PaperPlane />
            </div>
            <div className='popupExplanation'>
              <b>לא ניתן להגדיר חשבון חדש - יש חבילה מותקנת על החשבון הקיים</b>
              <br />
              <br />
              לבירורים נוספים מוזמנים לפנות <br /> לאיש קשר בארגונך
            </div>
            <BtnRightSideText
              isBusiness={true}
              text='סיום'
              onclick={() => {
                setPopUpNewBan(false);
              }}
            />
          </PopUp>
        </div>
        <div className='cellcomSeparatedIdInsert_separatedFooter'>
          <BtnRightSideText text='המשך' isBusiness={true} isGreyBg={!thisId || !is_israeli_id_number(thisId)} />
        </div>
      </form>
    </>
  );
};

export default IdInsertScreen;
